import { jwtDecode } from 'jwt-decode';

export function isAccessTokenValid(): boolean {
  const token = localStorage.getItem('accessToken');
  if (!token) return false;

  try {
    const decoded: any = jwtDecode(token);
    const now = Math.floor(Date.now() / 1000);
    return decoded.exp && decoded.exp > now;
  } catch {
    return false;
  }
}
